import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { nl } from './locales/nl';
import { en } from './locales/en';

export type Locale = 'nl' | 'en';
export const LOCALE_STORAGE_KEY = 'vht:locale';

function getInitialLocale(): Locale {
  try {
    return localStorage.getItem(LOCALE_STORAGE_KEY) === 'en' ? 'en' : 'nl';
  } catch {
    return 'nl';
  }
}

void i18n.use(initReactI18next).init({
  resources: { nl: { translation: nl }, en: { translation: en } },
  lng: getInitialLocale(),
  fallbackLng: 'nl',
  interpolation: { escapeValue: false },
});

export default i18n;
